import {inject} from '@angular/core';
import {Router, CanActivateFn} from '@angular/router';
import {AuthService} from '@services/auth.service';

export const authCheckGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const publicRoutes = ['/login', '/callback', '/auth-error'];
  if (publicRoutes.some(publicRoute => state.url.startsWith(publicRoute))) {
    return true;
  }

  const isAuth = authService.isAuthenticated();

  if (isAuth) {
    if (!authService.hasAllowedRole()) {
      authService.logout();
      return router.createUrlTree(['/login'], {
        queryParams: {returnUrl: state.url, error: 'insufficient_permissions'}
      });
    }

    if (state.url === '/login') {
      return router.createUrlTree(['/crop-monitoring']);
    }
    return true;
  }

  return router.createUrlTree(['/login'], {
    queryParams: {returnUrl: state.url}
  });
};
